import Omninano from '../../assets/Image/omni-nano.jpeg';

export const CC = (
    <div>
        <p className="title"><b>College Curriculum</b></p>
        <p>
            <span className="programs-span"><b>Please notice:</b></span><br />
            We encourage educators to visit the <a href="nano.gov"><span className="nano-gov">nano.gov</span></a> website for existing nationwide resources. A large amount of educational materials and links to nanotechnology networks are available at:
            <br /><br />
            <a href="https://www.nano.gov/education-training"><button className="programs-button">Nano Education Training</button></a>
            <a href="https://www.nnci.net/resources-educators-k-16"><button className="programs-button">Resource for Educators (K-16)</button></a>
            <br /><br />
            The following section will build gradually over the years and contain curriculum and activities that are developed by SDNI or its school/college partners, or jsgntly with such school/college partners.
        </p>
        <span className="programs-span"><b>Omni Nano</b></span><br />
        <img className="img-fluid" style={{ width: 150, height: 150 }} src={Omninano}></img><br />
        Omni Nano and SDNI are partnering for Nanotechnology curriculum development and educational outreach. We invite you to visit the <a href="https://omninano.org">Omni Nano Website</a>
        <br /><br />
        <span className="programs-span"><b>SDNI</b></span><br />
        The following section will build gradually over the years and contain curriculum and activities that are developed by SDNI or its school/college partners, or jointly with such school/college partners.
        <br /><br />
        <h4><br />Integrated Photonics Education Kit<br /><br /></h4>
        <a href="https://drive.google.com/file/d/0B-PWal97iJz6RmluUDVRM1J2b19sUDhKTVM0b2F6Vlc2b1V3/view?usp=sharing"><button className="programs-button">Learn More</button></a>
        <p></p>
        <table>
            <tbody>
                <tr>
                    <td width="75%" className="text">Assessing Water Quality - Is Nano Better</td>
                    <td with="25%">
                        <a href="https://drive.google.com/open?id=1nNyH2uSvtrCla0OAJ-8V_NdNnuC-NwrX">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td width="75%" className="text">Effect of Silver Nanoparticles on Bacterial Growth</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/1XsiF6OkocY1d5077Vp-MTxlUSh7ff4Dn/view?usp=sharing">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td width="75%" className="text">Flower Phenotype Diversity and Pollen Types</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/1_lzt3ErQ1KgPog4P0Nu4KfKnbHx9SP0g/view?usp=sharing">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td width="75%" className="text">Gecko Feet Adhesion - Scientific Method, Biomimecry, Nanotechnology</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/1XNqv6p9lqfGyH_Qjq2gk0eZhVAP5V8Hf/view?usp=sharing">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td width="75%" className="text">Gold Nanoparticles - Size-Dependent Colors</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/15Jy42tGLHkvceFUFl68CoFO0Y8pWXX_Q/view?usp=sharing">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td width="75%" className="text">Fluorescence and Quantum Dots</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/1acOjiJRsb-_N3mp4Q_-0oiuRVs-VkNdB/view?usp=sharing">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td width="75%" className="text">Synthesis and Characterization of Calcium Nanoparticles</td>
                    <td with="25%">
                        <a href="https://drive.google.com/file/d/1ISCLp_7yRAFJSgnrWeR67lwepz8Gjcxs/view?usp=sharing">
                            <button className="programs-small-button">Learn More</button>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <br /><br />
    </div>
)